// extracted by mini-css-extract-plugin
export default {"wrapper":"aBu2ho9LiFca5sWJOlZV"};